<header>
  <h1>
    Local Offers
    <button
      (click)="editLocalOffer()"
      color="primary"
      mat-mini-fab
      matTooltip="Add Local Offer"
      >
      <mat-icon>add</mat-icon>
    </button>
  </h1>
  <search-text (search)="setSearch($event)"></search-text>
</header>
<section class="audit-log">
  @if (loading) {
    <mat-card class="loading">
      <mat-card-content>
        <mat-icon>autorenew</mat-icon>
        Loading&hellip;
      </mat-card-content>
    </mat-card>
  }
  @if (!loading) {
    @if (!LocalOffers?.length) {
      <mat-card class="no-results">
        <mat-card-content>
          <mat-icon>sentiment_dissatisfied</mat-icon>
          No local offers found
        </mat-card-content>
      </mat-card>
    }
    @if (!!LocalOffers.length) {
      <table mat-table [dataSource]="LocalOffers">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container matColumnDef="company_name">
          <th mat-header-cell *matHeaderCellDef>Company Name</th>
          <td mat-cell *matCellDef="let row">{{row.company_name }}</td>
        </ng-container>
        <ng-container matColumnDef="offer">
          <th mat-header-cell *matHeaderCellDef>Offer</th>
          <td mat-cell *matCellDef="let row">{{row.offer }}</td>
        </ng-container>
        <!-- <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">{{row.description}}</td>
      </ng-container> -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="actions">
          <button
            (click)="editLocalOffer(row)"
            mat-icon-button
            matTooltip="Edit local offer"
            >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            (click)="listCategories(row.offer_id)"
            mat-icon-button
            matTooltip="View page categories"
            >
            <mat-icon>bookmark</mat-icon>
          </button>
          <button
            (click)="deleteLocalOffer(row)"
            mat-icon-button
            matTooltip="Delete Local Offer"
            >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>
    </table>
    @if (PageEvent) {
      <mat-paginator
        (page)="DataSource.loadWithPageEvent($event)"
        [length]="PageEvent.length"
        [pageIndex]="PageEvent.pageIndex"
        [pageSize]="PageEvent.pageSize"
      ></mat-paginator>
    }
  }
}
</section>
